export interface WebcamEntry {
  id: string;
  locationSlug: string;
  nameEn: string;
  nameDe: string;
  nameFr: string;
  nameIt: string;
  nameNl: string;
  region: "dalmatia" | "istria" | "kvarner" | "central-croatia" | "lika" | "slavonia";
  category: "city" | "beach" | "harbor" | "nature" | "park" | "island";
  lat: number;
  lon: number;
  embedUrl: string;
  embedType: "stream" | "map";
  externalLinks: { labelEn: string; labelDe: string; labelFr: string; labelIt: string; labelNl: string; url: string }[];
}

function whatsupcam(id: string): string {
  return `https://services.whatsupcams.com/wgt/${id}`;
}

function ipcam(alias: string): string {
  return `https://g0.ipcamlive.com/player/player.php?alias=${alias}&disablefullscreen=1`;
}

function windyWebcamMap(lat: number, lon: number, zoom = 13): string {
  return `https://embed.windy.com/embed.html?type=map&location=coordinates&lat=${lat}&lon=${lon}&zoom=${zoom}&overlay=webcams&level=surface&metricRain=mm&metricTemp=%C2%B0C&metricWind=km%2Fh`;
}

export const WEBCAM_DATA: WebcamEntry[] = [
  {
    id: "dubrovnik-pile",
    locationSlug: "dubrovnik",
    nameEn: "Dubrovnik – Pile Gate Live Cam",
    nameDe: "Dubrovnik – Pile-Tor Live-Cam",
    nameFr: "Dubrovnik – Caméra Live Porte de Pile",
    nameIt: "Dubrovnik – Cam Live Porta Pile",
    nameNl: "Dubrovnik – Live Cam Pile Poort",
    region: "dalmatia",
    category: "city",
    lat: 42.6415,
    lon: 18.1102,
    embedUrl: ipcam("5cdea3399fead"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Old Town Live Cam", labelDe: "Altstadt Live-Cam", labelFr: "Vieille Ville Live", labelIt: "Città Vecchia Live", labelNl: "Oude Stad Live", url: "https://www.windy.com/-Webcams/Croatia/Dubrovnik/cr?webcams,42.641,18.110,13" },
    ],
  },
  {
    id: "dubrovnik-ilijina",
    locationSlug: "dubrovnik",
    nameEn: "Dubrovnik – Ilijina Glavica Panorama",
    nameDe: "Dubrovnik – Ilijina Glavica Panorama",
    nameFr: "Dubrovnik – Panorama Ilijina Glavica",
    nameIt: "Dubrovnik – Panorama Ilijina Glavica",
    nameNl: "Dubrovnik – Ilijina Glavica Panorama",
    region: "dalmatia",
    category: "city",
    lat: 42.6390,
    lon: 18.1050,
    embedUrl: ipcam("5cdea385284fc"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Dubrovnik Panorama Cam", labelDe: "Dubrovnik Panorama-Kamera", labelFr: "Panorama Dubrovnik", labelIt: "Panorama Dubrovnik", labelNl: "Dubrovnik Panorama", url: "https://www.windy.com/-Webcams/Croatia/Dubrovnik/cr?webcams,42.640,18.106,13" },
    ],
  },
  {
    id: "split-riva",
    locationSlug: "split",
    nameEn: "Split – Riva Promenade Live Cam",
    nameDe: "Split – Riva Promenade Live-Cam",
    nameFr: "Split – Caméra Live Promenade Riva",
    nameIt: "Split – Cam Live Passeggiata Riva",
    nameNl: "Split – Live Cam Riva Promenade",
    region: "dalmatia",
    category: "city",
    lat: 43.5081,
    lon: 16.4402,
    embedUrl: whatsupcam("hr_split04"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Split Harbour Webcam", labelDe: "Hafen Split Webcam", labelFr: "Webcam Port de Split", labelIt: "Webcam Porto di Split", labelNl: "Haven Split Webcam", url: "https://www.windy.com/-Webcams/Croatia/Split/cr?webcams,43.508,16.440,13" },
      { labelEn: "Split City Cam", labelDe: "Split Stadtcam", labelFr: "Caméra Ville Split", labelIt: "Cam Città Split", labelNl: "Split Stadscam", url: "https://www.livecamcroatia.com/najljepse-marine-i-lucice-hrvatske/split-riva-hrvatskog-preporoda-web-kamera/" },
    ],
  },
  {
    id: "split-bacvice",
    locationSlug: "split",
    nameEn: "Split – Bačvice Beach Live Cam",
    nameDe: "Split – Strand Bačvice Live-Cam",
    nameFr: "Split – Caméra Live Plage Bačvice",
    nameIt: "Split – Cam Live Spiaggia Bačvice",
    nameNl: "Split – Live Cam Strand Bačvice",
    region: "dalmatia",
    category: "beach",
    lat: 43.5033,
    lon: 16.4490,
    embedUrl: whatsupcam("hr_split05"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Bačvice Beach Cam", labelDe: "Strand Bačvice Kamera", labelFr: "Caméra Plage Bačvice", labelIt: "Camera Spiaggia Bačvice", labelNl: "Strand Bačvice Cam", url: "https://www.windy.com/-Webcams/Croatia/Split/cr?webcams,43.503,16.449,14" },
    ],
  },
  {
    id: "split-harbor",
    locationSlug: "split",
    nameEn: "Split – Ferry Harbour Live Cam",
    nameDe: "Split – Fähren Hafen Live-Cam",
    nameFr: "Split – Caméra Live Port Ferries",
    nameIt: "Split – Cam Live Porto Traghetti",
    nameNl: "Split – Live Cam Veerboothaven",
    region: "dalmatia",
    category: "harbor",
    lat: 43.5060,
    lon: 16.4350,
    embedUrl: whatsupcam("hr_split06"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Split Harbour View", labelDe: "Hafen Ansicht Split", labelFr: "Vue Port de Split", labelIt: "Vista Porto Split", labelNl: "Haven Uitzicht Split", url: "https://www.windy.com/-Webcams/Croatia/Split/cr?webcams,43.506,16.435,13" },
    ],
  },
  {
    id: "pula-arena",
    locationSlug: "pula",
    nameEn: "Pula – Roman Arena Live Cam",
    nameDe: "Pula – Römische Arena Live-Cam",
    nameFr: "Pula – Caméra Live Arène Romaine",
    nameIt: "Pula – Cam Live Arena Romana",
    nameNl: "Pula – Live Cam Romeins Amfitheater",
    region: "istria",
    category: "city",
    lat: 44.8731,
    lon: 13.8480,
    embedUrl: whatsupcam("hr_pula01"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Pula Arena Webcam", labelDe: "Pula Arena Webcam", labelFr: "Webcam Arène de Pula", labelIt: "Webcam Arena di Pola", labelNl: "Pula Arena Webcam", url: "https://www.windy.com/-Webcams/Croatia/Pula/cr?webcams,44.873,13.848,13" },
    ],
  },
  {
    id: "porec-harbor",
    locationSlug: "porec",
    nameEn: "Poreč – Marina Live Cam",
    nameDe: "Poreč – Marina Live-Cam",
    nameFr: "Poreč – Caméra Live Marina",
    nameIt: "Poreč – Cam Live Marina",
    nameNl: "Poreč – Live Cam Marina",
    region: "istria",
    category: "harbor",
    lat: 45.2268,
    lon: 13.5942,
    embedUrl: whatsupcam("hr_porec02"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Poreč Marina Cam", labelDe: "Poreč Marina Kamera", labelFr: "Caméra Marina Poreč", labelIt: "Camera Marina Poreč", labelNl: "Poreč Marina Cam", url: "https://www.windy.com/-Webcams/Croatia/Porec/cr?webcams,45.227,13.594,13" },
    ],
  },
  {
    id: "sibenik-oldtown",
    locationSlug: "sibenik",
    nameEn: "Šibenik – Old Town Live Cam",
    nameDe: "Šibenik – Altstadt Live-Cam",
    nameFr: "Šibenik – Caméra Live Vieille Ville",
    nameIt: "Šibenik – Cam Live Città Vecchia",
    nameNl: "Šibenik – Live Cam Oude Stad",
    region: "dalmatia",
    category: "city",
    lat: 43.7350,
    lon: 15.8952,
    embedUrl: whatsupcam("hr_sibenik01"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Šibenik Cathedral Cam", labelDe: "Šibenik Dom-Kamera", labelFr: "Caméra Cathédrale Šibenik", labelIt: "Camera Cattedrale Šibenik", labelNl: "Šibenik Kathedraal Cam", url: "https://www.windy.com/-Webcams/Croatia/Sibenik/cr?webcams,43.735,15.895,13" },
    ],
  },
  {
    id: "trogir-oldtown",
    locationSlug: "trogir",
    nameEn: "Trogir – Old Town Live Cam",
    nameDe: "Trogir – Altstadt Live-Cam",
    nameFr: "Trogir – Caméra Live Vieille Ville",
    nameIt: "Trogir – Cam Live Città Vecchia",
    nameNl: "Trogir – Live Cam Oude Stad",
    region: "dalmatia",
    category: "city",
    lat: 43.5151,
    lon: 16.2509,
    embedUrl: whatsupcam("hr_trogir01"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Trogir Old Town Cam", labelDe: "Trogir Altstadt Kamera", labelFr: "Caméra Vieille Ville Trogir", labelIt: "Camera Città Vecchia Trogir", labelNl: "Trogir Oude Stad Cam", url: "https://www.windy.com/-Webcams/Croatia/Trogir/cr?webcams,43.515,16.251,14" },
    ],
  },
  {
    id: "makarska-beach",
    locationSlug: "makarska",
    nameEn: "Makarska – Beach Live Cam",
    nameDe: "Makarska – Strand Live-Cam",
    nameFr: "Makarska – Caméra Live Plage",
    nameIt: "Makarska – Cam Live Spiaggia",
    nameNl: "Makarska – Live Cam Strand",
    region: "dalmatia",
    category: "beach",
    lat: 43.2953,
    lon: 17.0179,
    embedUrl: whatsupcam("hr_makarska02"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Makarska Beach Cam", labelDe: "Makarska Strand Kamera", labelFr: "Caméra Plage Makarska", labelIt: "Camera Spiaggia Makarska", labelNl: "Makarska Strand Cam", url: "https://www.windy.com/-Webcams/Croatia/Makarska/cr?webcams,43.295,17.018,13" },
    ],
  },
  {
    id: "krk-town",
    locationSlug: "krk",
    nameEn: "Krk – Town Harbour Live Cam",
    nameDe: "Krk – Stadthafen Live-Cam",
    nameFr: "Krk – Caméra Live Port de Ville",
    nameIt: "Krk – Cam Live Porto Città",
    nameNl: "Krk – Live Cam Stadshaven",
    region: "kvarner",
    category: "island",
    lat: 45.0268,
    lon: 14.5755,
    embedUrl: whatsupcam("hr_krk02"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Krk Town Cam", labelDe: "Krk Hafen Kamera", labelFr: "Caméra Port de Krk", labelIt: "Camera Porto Krk", labelNl: "Krk Stad Cam", url: "https://www.windy.com/-Webcams/Croatia/Krk/cr?webcams,45.027,14.576,13" },
    ],
  },
  {
    id: "rab-oldtown",
    locationSlug: "rab",
    nameEn: "Rab – Old Town Live Cam",
    nameDe: "Rab – Altstadt Live-Cam",
    nameFr: "Rab – Caméra Live Vieille Ville",
    nameIt: "Rab – Cam Live Città Vecchia",
    nameNl: "Rab – Live Cam Oude Stad",
    region: "kvarner",
    category: "island",
    lat: 44.7574,
    lon: 14.7643,
    embedUrl: whatsupcam("hr_rab01"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Rab Old Town Cam", labelDe: "Rab Altstadt Kamera", labelFr: "Caméra Vieille Ville Rab", labelIt: "Camera Città Vecchia Rab", labelNl: "Rab Oude Stad Cam", url: "https://www.windy.com/-Webcams/Croatia/Rab/cr?webcams,44.757,14.764,13" },
    ],
  },
  {
    id: "opatija-waterfront",
    locationSlug: "opatija",
    nameEn: "Opatija – Lungomare Live Cam",
    nameDe: "Opatija – Lungomare Live-Cam",
    nameFr: "Opatija – Caméra Live Lungomare",
    nameIt: "Opatija – Cam Live Lungomare",
    nameNl: "Opatija – Live Cam Lungomare",
    region: "kvarner",
    category: "city",
    lat: 45.3378,
    lon: 14.3091,
    embedUrl: whatsupcam("hr_opatija01"),
    embedType: "stream",
    externalLinks: [
      { labelEn: "Opatija Promenade Cam", labelDe: "Opatija Promenade Kamera", labelFr: "Caméra Promenade Opatija", labelIt: "Camera Promenade Opatija", labelNl: "Opatija Promenade Cam", url: "https://www.windy.com/-Webcams/Croatia/Opatija/cr?webcams,45.338,14.309,13" },
    ],
  },
  {
    id: "hvar-harbor",
    locationSlug: "hvar",
    nameEn: "Hvar – Town & Harbour Webcam Map",
    nameDe: "Hvar – Stadt & Hafen Webcam-Karte",
    nameFr: "Hvar – Carte Webcams Ville & Port",
    nameIt: "Hvar – Mappa Webcam Città & Porto",
    nameNl: "Hvar – Webcam Kaart Stad & Haven",
    region: "dalmatia",
    category: "harbor",
    lat: 43.1729,
    lon: 16.4413,
    embedUrl: windyWebcamMap(43.1729, 16.4413, 13),
    embedType: "map",
    externalLinks: [
      { labelEn: "Hvar Town Harbour", labelDe: "Hafen Hvar Stadt", labelFr: "Port de la Ville de Hvar", labelIt: "Porto di Hvar", labelNl: "Haven van Hvar", url: "https://www.windy.com/-Webcams/Croatia/Hvar/cr?webcams,43.173,16.441,13" },
    ],
  },
  {
    id: "zadar-waterfront",
    locationSlug: "zadar",
    nameEn: "Zadar – Old Town Webcam Map",
    nameDe: "Zadar – Altstadt Webcam-Karte",
    nameFr: "Zadar – Carte Webcams Vieille Ville",
    nameIt: "Zadar – Mappa Webcam Città Vecchia",
    nameNl: "Zadar – Webcam Kaart Oude Stad",
    region: "dalmatia",
    category: "city",
    lat: 44.1194,
    lon: 15.2314,
    embedUrl: windyWebcamMap(44.1194, 15.2314, 13),
    embedType: "map",
    externalLinks: [
      { labelEn: "Zadar Waterfront Cam", labelDe: "Zadar Uferpromenade Kamera", labelFr: "Caméra Front de Mer Zadar", labelIt: "Camera Lungomare Zadar", labelNl: "Zadar Waterkant Cam", url: "https://www.windy.com/-Webcams/Croatia/Zadar/cr?webcams,44.119,15.231,13" },
    ],
  },
  {
    id: "rovinj-harbor",
    locationSlug: "rovinj",
    nameEn: "Rovinj – Harbour Webcam Map",
    nameDe: "Rovinj – Hafen Webcam-Karte",
    nameFr: "Rovinj – Carte Webcams Port",
    nameIt: "Rovinj – Mappa Webcam Porto",
    nameNl: "Rovinj – Webcam Kaart Haven",
    region: "istria",
    category: "harbor",
    lat: 45.0812,
    lon: 13.6387,
    embedUrl: windyWebcamMap(45.0812, 13.6387, 13),
    embedType: "map",
    externalLinks: [
      { labelEn: "Rovinj Old Town Harbour", labelDe: "Altstadt Hafen Rovinj", labelFr: "Port Vieille Ville Rovinj", labelIt: "Porto Città Vecchia Rovinj", labelNl: "Oude Stad Haven Rovinj", url: "https://www.windy.com/-Webcams/Croatia/Rovinj/cr?webcams,45.081,13.639,13" },
    ],
  },
  {
    id: "brac-zlatni-rat",
    locationSlug: "brac",
    nameEn: "Brač – Zlatni Rat Webcam Map",
    nameDe: "Brač – Zlatni Rat Webcam-Karte",
    nameFr: "Brač – Carte Webcams Zlatni Rat",
    nameIt: "Brač – Mappa Webcam Zlatni Rat",
    nameNl: "Brač – Webcam Kaart Zlatni Rat",
    region: "dalmatia",
    category: "beach",
    lat: 43.3249,
    lon: 16.6353,
    embedUrl: windyWebcamMap(43.3249, 16.6353, 13),
    embedType: "map",
    externalLinks: [
      { labelEn: "Zlatni Rat Beach Cam", labelDe: "Zlatni Rat Strand Kamera", labelFr: "Caméra Plage Zlatni Rat", labelIt: "Camera Spiaggia Zlatni Rat", labelNl: "Zlatni Rat Strand Cam", url: "https://www.windy.com/-Webcams/Croatia/Bol/cr?webcams,43.263,16.659,13" },
    ],
  },
  {
    id: "korcula-oldtown",
    locationSlug: "korcula",
    nameEn: "Korčula – Old Town Webcam Map",
    nameDe: "Korčula – Altstadt Webcam-Karte",
    nameFr: "Korčula – Carte Webcams Vieille Ville",
    nameIt: "Korčula – Mappa Webcam Città Vecchia",
    nameNl: "Korčula – Webcam Kaart Oude Stad",
    region: "dalmatia",
    category: "island",
    lat: 42.9630,
    lon: 17.1344,
    embedUrl: windyWebcamMap(42.9630, 17.1344, 13),
    embedType: "map",
    externalLinks: [
      { labelEn: "Korčula Old Town Harbour", labelDe: "Altstadt Hafen Korčula", labelFr: "Port Vieille Ville Korčula", labelIt: "Porto Città Vecchia Korčula", labelNl: "Oude Stad Haven Korčula", url: "https://www.windy.com/-Webcams/Croatia/Korcula/cr?webcams,42.963,17.134,13" },
    ],
  },
  {
    id: "plitvice-lakes",
    locationSlug: "plitvice",
    nameEn: "Plitvice Lakes – Webcam Map",
    nameDe: "Plitvicer Seen – Webcam-Karte",
    nameFr: "Lacs de Plitvice – Carte Webcams",
    nameIt: "Laghi di Plitvice – Mappa Webcam",
    nameNl: "Plitvice Meren – Webcam Kaart",
    region: "lika",
    category: "nature",
    lat: 44.8804,
    lon: 15.6165,
    embedUrl: windyWebcamMap(44.8804, 15.6165, 12),
    embedType: "map",
    externalLinks: [
      { labelEn: "Plitvice Lakes View", labelDe: "Plitvicer Seen Ansicht", labelFr: "Vue Lacs de Plitvice", labelIt: "Vista Laghi di Plitvice", labelNl: "Plitvice Meren Uitzicht", url: "https://www.windy.com/-Webcams/Croatia/Plitvice-Lakes/cr?webcams,44.880,15.617,12" },
    ],
  },
  {
    id: "zagreb-center",
    locationSlug: "zagreb",
    nameEn: "Zagreb – City Centre Webcam Map",
    nameDe: "Zagreb – Stadtzentrum Webcam-Karte",
    nameFr: "Zagreb – Carte Webcams Centre-Ville",
    nameIt: "Zagreb – Mappa Webcam Centro Città",
    nameNl: "Zagreb – Webcam Kaart Stadscentrum",
    region: "central-croatia",
    category: "city",
    lat: 45.8150,
    lon: 15.9819,
    embedUrl: windyWebcamMap(45.8150, 15.9819, 13),
    embedType: "map",
    externalLinks: [
      { labelEn: "Zagreb City Cam", labelDe: "Zagreb Stadtcam", labelFr: "Caméra Centre Zagreb", labelIt: "Camera Centro Zagreb", labelNl: "Zagreb Stadscam", url: "https://www.windy.com/-Webcams/Croatia/Zagreb/cr?webcams,45.813,15.977,13" },
    ],
  },
];

export function getWebcamsBySlug(locationSlug: string): WebcamEntry[] {
  return WEBCAM_DATA.filter(w => w.locationSlug === locationSlug);
}

export function getWebcamsByRegion(region: string): WebcamEntry[] {
  return WEBCAM_DATA.filter(w => w.region === region);
}

export const REGION_LABELS: Record<string, { en: string; de: string; fr: string; it: string; nl: string; hr: string; pl: string }> = {
  dalmatia: { en: "Dalmatia", de: "Dalmatien", fr: "Dalmatie", it: "Dalmazia", nl: "Dalmatië", hr: "Dalmacija", pl: "Dalmacja" },
  istria: { en: "Istria", de: "Istrien", fr: "Istrie", it: "Istria", nl: "Istrië", hr: "Istra", pl: "Istria" },
  kvarner: { en: "Kvarner", de: "Kvarner", fr: "Kvarner", it: "Quarnero", nl: "Kvarner", hr: "Kvarner", pl: "Kvarner" },
  "central-croatia": { en: "Central Croatia", de: "Zentralkroatien", fr: "Croatie Centrale", it: "Croazia Centrale", nl: "Centraal Kroatië", hr: "Središnja Hrvatska", pl: "Środkowa Chorwacja" },
  lika: { en: "Lika & Gorski Kotar", de: "Lika & Gorski Kotar", fr: "Lika & Gorski Kotar", it: "Lika & Gorski Kotar", nl: "Lika & Gorski Kotar", hr: "Lika & Gorski Kotar", pl: "Lika & Gorski Kotar" },
  slavonia: { en: "Slavonia", de: "Slawonien", fr: "Slavonie", it: "Slavonia", nl: "Slavonië", hr: "Slavonija", pl: "Slawonia" },
};
